import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

type ResizePreviewIconSvgProps = {
  style?: React.CSSProperties
  className?: string
}

/**
 * Renders a ResizePreviewIconSvg component.
 *
 * @param {ResizePreviewIconSvgProps} props
 * @prop {React.CSSProperties} [style] - The CSS style to apply to the component.
 * @prop {string} [className] - The CSS class to apply to the component.
 *
 * @returns {JSX.Element} A JSX element representing the icon.
 */
function ResizePreviewIconSvg({ style, className }: ResizePreviewIconSvgProps) {
  return (
    <svg
      className={className}
      style={style}
      width="1em"
      height="1em"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="5" height="5" fill="white" />
      <rect y="9" width="5" height="5" fill="white" />
      <rect x="9" y="9" width="5" height="5" fill="white" />
      <rect y="18" width="5" height="5" fill="white" />
      <rect x="9" width="5" height="5" fill="white" />
      <rect x="18" width="5" height="5" fill="white" />
    </svg>
  )
}

ResizePreviewIconSvg.defaultProps = {
  style: {},
  className: ''
}

/**
 * Renders a ResizePreviewIcon component.
 *
 * @param {Partial<CustomIconComponentProps> & { size?: number | string }} props
 * @prop {number | string} [size] - The font size of the icon.
 * @prop {React.CSSProperties} [style] - The CSS style to apply to the component.
 * @prop {*} ...rest - Any additional props to pass to the underlying Icon component.
 *
 * @returns {JSX.Element} A JSX element representing the icon.
 */
function ResizePreviewIcon(
  props: Partial<CustomIconComponentProps> & { size?: number | string }
) {
  const { size = 20, style = {}, ...rest } = props

  return (
    <Icon
      component={ResizePreviewIconSvg}
      style={{ fontSize: size, ...style }}
      {...rest}
    />
  )
}

ResizePreviewIcon.defaultProps = {
  size: 20
}

export default ResizePreviewIcon
